import { render, staticRenderFns } from "./Firmantes.vue?vue&type=template&id=19dbed46&"
import script from "./Firmantes.vue?vue&type=script&lang=js&"
export * from "./Firmantes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports